var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.189715 0.189191C0.433793 -0.0548871 0.829521 -0.054887 1.0736 0.189191L5.00052 4.11612L8.92745 0.189191C9.17153 -0.0548868 9.56726 -0.0548871 9.81133 0.189191C10.0554 0.433268 10.0554 0.828997 9.81133 1.07307L5.88441 5L9.81133 8.92693C10.0554 9.171 10.0554 9.56673 9.81133 9.81081C9.56726 10.0549 9.17153 10.0549 8.92745 9.81081L5.00052 5.88388L1.0736 9.81081C0.829521 10.0549 0.433793 10.0549 0.189715 9.81081C-0.0543626 9.56673 -0.0543625 9.171 0.189715 8.92693L4.11664 5L0.189715 1.07307C-0.0543625 0.828997 -0.0543626 0.433268 0.189715 0.189191Z",
    fill: "#4D4D5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.46c6e08fd20d1172b5d64b6756acea77.svg";
export { ForwardRef as ReactComponent };